export const getCityConfigUrl = "/api/v3/org/city_config/search";
export const uploadCityConfigUrl = "/api/v3/org/city_config/upload";
export const downloadCityConfigExcelTemplateUrl =
  "/api/v3/org/city_config/template";
